
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { Forgot } from '@/models/forgot';
import authService from '@/services/auth-services';

@Component({
    components: {
        Loading,
    },
})
export default class Login extends Vue {
    private isLoading = false;
    private email = '';
    constructor() {
        super();
    }

    private async submit() {
        const isValid = await (this.$refs['observer'] as any).validate();

        if (isValid && !this.isLoading) {
            this.isLoading = true;
            const dataRequest: Forgot = {
                email: this.email
            };

            const result  = await authService.forgot(dataRequest);
            this.isLoading = false;
            if (result && result.status === 200 && result.data.data.success) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Vui lòng kiểm tra email để lấy lại mật khẩu!',
                });
                this.email = '';
            } else {
                 Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Địa chỉ email không tồn tại trong hệ thống!',
                });
            }
        }
    }
}
